import React from 'react';
import { UnlayerEmailsTabView } from '@/components/views/UnlayerEmailsView/UnlayerEmailsTabView';

export const UnlayerTemplatesPage = () => {
	return <UnlayerEmailsTabView />;
};
